export default "__VITE_ASSET__2c9dd9f9__"